<form class="form" [formGroup]="form" (ngSubmit)="enviar()" novalidate>
  <div class="fields" [hidden]="enRevision">
    <ng-content></ng-content>

    <div class="fld" (keydown.escape)="ayudaAbierta = false">
      <div class="lbl2-row">
        <span class="lbl2" id="lbl-causal">Causal de liberación</span>
        <button type="button" class="info-btn" *ngIf="atajos.length" (click)="ayudaAbierta = !ayudaAbierta"
          [attr.aria-expanded]="ayudaAbierta" aria-controls="ayuda-atajos" aria-label="¿De dónde salen estos atajos?">
          <mat-icon aria-hidden="true">info_outline</mat-icon>
        </button>
      </div>
      <div class="atajos-info" id="ayuda-atajos" *ngIf="ayudaAbierta && atajos.length">
        <p class="atajos-info-t">{{ hayUso ? 'Las más usadas en los últimos ' + diasTop + ' días' + (pais ? ' · ' + pais : '') : 'Causales frecuentes en esta pantalla' }}</p>
        <ul>
          <li *ngFor="let a of atajos; trackBy: trackByCodigo">
            <span>{{ a.DES }}</span>
            <span class="num" *ngIf="a.total !== null">{{ a.total }} {{ a.total === 1 ? 'liberación' : 'liberaciones' }}</span>
          </li>
        </ul>
      </div>
      <div class="causales-estado" role="status" *ngIf="cargandoCausales"><span class="girar" aria-hidden="true"></span>Cargando causales…</div>
      <div class="err-msg" role="alert" *ngIf="errorCausales">No se pudieron cargar las causales. Recarga la página e intenta de nuevo.</div>
      <div class="qchips" role="group" aria-label="Causales más usadas" *ngIf="atajos.length">
        <button type="button" class="qchip" *ngFor="let a of atajos; trackBy: trackByCodigo"
          [attr.aria-pressed]="form.value.causal === a.COD_CAUSAL" (click)="elegirAtajo(a)">{{ a.DES }}</button>
      </div>
      <select #causalSelect id="f-causal" formControlName="causal" aria-labelledby="lbl-causal"
        [class.invalid]="!!errorCausal" [attr.aria-invalid]="!!errorCausal" style="margin-top: 8px">
        <option value="">{{ cargandoCausales ? 'Cargando causales…' : 'Elige una causal' }}</option>
        <option *ngFor="let m of motivos; trackBy: trackByCodigo" [value]="m.COD_CAUSAL">{{ m.DES }}</option>
      </select>
      <div class="err-msg" role="alert" *ngIf="errorCausal">{{ errorCausal }}</div>
    </div>

    <div class="fld">
      <label for="f-obs">Detalle para el asesor</label>
      <textarea #detalleArea id="f-obs" formControlName="detalle" [attr.maxlength]="detalleMax"
        placeholder="Escribe qué pasó con el pedido" [class.invalid]="!!errorDetalle"
        [attr.aria-invalid]="!!errorDetalle" aria-describedby="ayuda-detalle"></textarea>
      <div class="help" id="ayuda-detalle">
        Entre {{ detalleMin }} y {{ detalleMax }} caracteres. Lo escribes tú: es lo que verá el asesor.
        <span class="num contador">{{ (form.value.detalle || '').length }}/{{ detalleMax }}</span>
      </div>
      <div class="err-msg" role="alert" *ngIf="errorDetalle">{{ errorDetalle }}</div>
    </div>
  </div>

  <div class="review" *ngIf="enRevision">
    <h3>Revisa antes de confirmar</h3>
    <dl>
      <div *ngFor="let f of filas"><dt>{{ f.k }}</dt><dd>{{ f.v }}</dd></div>
    </dl>
    <app-que-pasara [lineas]="consecuencias"></app-que-pasara>
  </div>

  <div class="actions">
    <button type="button" class="btn btn-ghost back" *ngIf="enRevision" (click)="enRevision = false" [disabled]="enviando">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>Volver a editar
    </button>
    <button #botonConfirmar type="submit" class="btn btn-primary go" [disabled]="enviando">
      <mat-icon aria-hidden="true">{{ enRevision ? 'check' : 'event_available' }}</mat-icon>
      {{ enRevision ? 'Confirmar liberación' : 'Revisar y liberar' }}
    </button>
  </div>
</form>
